import { TranslatePipe } from '@myre/ui-primitive-core';
import { MyreIconTooltipComponent } from '@myre/ui-primitive-tooltip';

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostBinding,
  inject,
  Input,
} from '@angular/core';
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  type ControlValueAccessor,
} from '@angular/forms';

export const SWITCH_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwitchComponent),
  multi: true,
};

@Component({
  selector: 'myre-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SWITCH_VALUE_ACCESSOR],
  imports: [FormsModule, MyreIconTooltipComponent, TranslatePipe],
})
export class SwitchComponent implements ControlValueAccessor {
  private _changeDetectorRef = inject(ChangeDetectorRef);

  @HostBinding('class.with-label')
  public get withLabel(): boolean {
    return !!this.label;
  }

  @Input()
  public label: string;

  @Input()
  public questionMarkTooltip: string;

  @Input()
  public fitHeight: boolean;

  @Input()
  public onLabel: string;

  @Input()
  public offLabel: string;

  @Input()
  public checked: boolean = false;

  public disabled: boolean = false;

  @Input()
  public readonly: boolean = false;

  @Input()
  public withBackground: boolean = true;

  public registerOnChange(fn: (value: boolean) => any): void {
    this._onModelChange = fn;
  }

  public registerOnTouched(fn: () => any): void {
    this._onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(checked: boolean): void {
    this.checked = checked;
    this._changeDetectorRef.detectChanges();
  }

  public onChange(checked: boolean): void {
    this.checked = checked;
    this._onModelChange(checked);
    this._changeDetectorRef.detectChanges();
  }

  public onBlur(): void {
    this._onTouched();
  }

  private _onModelChange: (value: boolean) => any = () => {};

  private _onTouched: () => any = () => {};
}
